import { render } from "./appMain.vue?vue&type=template&id=0c8c7640&scoped=true&ts=true"
import script from "./appMain.vue?vue&type=script&lang=ts"
export * from "./appMain.vue?vue&type=script&lang=ts"

import "./appMain.vue?vue&type=style&index=0&id=0c8c7640&lang=scss&scoped=true"

import exportComponent from "E:\\bjft\\bjjc-merchant-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c8c7640"]])

export default __exports__